import React from 'react'

interface IField {
    title: string
    children: string | React.ReactNode
}

const Field: React.FC<IField> = ({ title, children }) => {
    return (
        <div className='field even:justify-center flex'>
            <div className=' flex flex-col'>
                <p className='text-sm font-bold text-gray-300'>{title}</p>
                <p className='text-base font-bold'>{children}</p>
            </div>
        </div>
    )
}

export default Field
